import {
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventStatusIncidentsOnFieldConfig } from '../../configuration'

export const eventStatusIncidentsOnFieldConfig: EventStatusIncidentsOnFieldConfig =
  {
    eventStatusToIncidentIdMap: new Map<
      VolleyballEventStatusId,
      VolleyballIncidentId[]
    >([
      [
        VolleyballEventStatusId.NotStarted,
        [
          VolleyballIncidentId.MatchAboutToStart,
          VolleyballIncidentId.FirstSetStarted,
        ],
      ],
      [
        VolleyballEventStatusId.StartDelayed,
        [
          VolleyballIncidentId.MatchAboutToStart,
          VolleyballIncidentId.FirstSetStarted,
        ],
      ],
      [
        VolleyballEventStatusId.BreakAfterFirstSet,
        [VolleyballIncidentId.SecondSetStarted],
      ],
      [
        VolleyballEventStatusId.BreakAfterSecondSet,
        [VolleyballIncidentId.ThirdSetStarted],
      ],
      [
        VolleyballEventStatusId.BreakAfterThirdSet,
        [VolleyballIncidentId.FourthSetStarted],
      ],
      [
        VolleyballEventStatusId.BreakAfterFourthSet,
        [VolleyballIncidentId.FifthSetStarted],
      ],
    ]),
    secondHalfIncidentId: VolleyballIncidentId.SecondSetStarted,
  }
